import React, { useState, useEffect, Fragment } from "react";
import { zl, isNumber } from "../../../functions/utilities";
import { mm_rrrr_to_date } from "../../../functions/dataFormat";

const ZbiorowyWydrukTFoot = ( props ) => {

    const { listaMsc, czyRok, przelewyRok, czynszeRok, czynszeWspolnota, przelewyWspolnota, rozliczenieWody } = props;
    
    const [sumaPrzelewyRok, setSumaPrzelewyRok] = useState(0);
    const [sumaCzynszeRok, setSumaCzynszeRok] = useState(0);
    const [rok, setRok] = useState(undefined);

    useEffect( () => {
        const temp = czyRok ? przelewyRok?.reduce((suma, item ) => suma + (Number(item.kwota) || 0),0) : 0;
        setSumaPrzelewyRok(temp);
    }, [czyRok, przelewyRok])

    useEffect( () => {
        const temp = czyRok ? czynszeRok?.reduce((suma, item) => suma + (Number(item.kwota) || 0),0) : 0;
        setSumaCzynszeRok(temp);
    }, [czyRok, czynszeRok]);

    useEffect( () => {
        const temp = czyRok ? (
            <td style={{whiteSpace: "nowrap", border: "1px solid black", padding: "1px 2px", textAlign: "right"}}>
                { zl( sumaPrzelewyRok - sumaCzynszeRok )}
            </td>
        ) : <Fragment></Fragment>;
        setRok(temp);
    }, [czyRok, sumaPrzelewyRok, sumaCzynszeRok]);

    const sumujNaleznosciMsc = (msc) => {
        let suma = 0;
        const sumaWody = rozliczenieWody?.find( r => r?.miesiac == msc)?.saldoTotal || 0;
        
        czynszeWspolnota?.forEach( czynsz => {
            czynsz?.grupy_udzial_msc?.forEach( grupa => {
                const mscTemp = grupa?.temp_msc?.find( g => g?.msc === msc)
                const lastTemp = grupa?.temp_msc[grupa?.temp_msc?.length - 1]
                const czynszTemp = mscTemp === undefined && mm_rrrr_to_date(msc) >= mm_rrrr_to_date(grupa?.temp_msc[grupa?.temp_msc?.length - 1].msc) ? lastTemp : mscTemp;
                suma += isNumber(czynszTemp?.czynsz_na_msc) && (czynszTemp?.czynsz_na_msc > 0 || czynszTemp?.czynsz_na_msc == 0 || czynszTemp?.czynsz_na_msc < 0 ) ? czynszTemp?.czynsz_na_msc : 0;
            })
        })
        return suma + sumaWody;
    }

    const sumujWplatyMsc = (msc) => {
        let suma = 0;
        przelewyWspolnota?.forEach(przelew => {
            przelew?.przelewy?.forEach( p => {
                if (p?.msc === msc)
                    suma += p?.kwota;
            })
        })
        return suma;
    }

    const podsumowanieRokTotal = () => {
        let naleznosci = 0, wplaty = 0;
        
        listaMsc?.forEach( m => {
            naleznosci += sumujNaleznosciMsc(m);
            wplaty += sumujWplatyMsc(m)
        });

        return (
            <Fragment>
                <td style={{whiteSpace: "nowrap", border: "1px solid black", padding: "1px 2px", textAlign: "right" }}>
                    {zl(naleznosci)}
                </td>
                <td style={{whiteSpace: "nowrap", border: "1px solid black", padding: "1px 2px", textAlign: "right" }}>
                    {zl(wplaty)}
                </td>
                <td style={{fontWeight: "600", whiteSpace: "nowrap", border: "1px solid black", padding: "1px 2px", textAlign: "right" }}>
                    {zl( (wplaty - naleznosci) + (sumaPrzelewyRok - sumaCzynszeRok) )}                    
                </td>
            </Fragment>
        )
    }

    const podsumowanieFooter = (
        <tr>
            <td colSpan={2} style={{border: "1px solid black"}}>

            </td>
            {
                czyRok ? (
                    <Fragment>
                        {rok}
                        {podsumowanieRokTotal()}
                    </Fragment>
                ) : (
                    <Fragment>
                        {podsumowanieRokTotal()}
                    </Fragment>
                )
            }
        </tr>
    )

    return (
        <tfoot>
            {podsumowanieFooter}
        </tfoot>
    ) 

}

export default ZbiorowyWydrukTFoot;